import queryString from 'query-string';
import type {
  DealConstruction,
  DealConstructionEdit
} from '~/models/DealConstruction';
import type {
  DealSettlement,
  DealSettlementEdit
} from '~/models/DealSettlement';
import type { NskResponse } from '~/models/Api';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';
import type { BillingType, DealBilling } from '~/models/DealBilling';
import { generatePath } from '~/utils/generatePath';
import { convertDealConstructionToPayload } from '~/utils/api/convertDealConstructionPayload';

const isDealConstructionEdit = (
  data: DealConstructionEdit | DealSettlementEdit
): data is DealConstructionEdit => 'dealConstructionItem' in data;

export const create = async (
  dealBilling: DealConstructionEdit | DealSettlementEdit,
  dealId: number,
  billingType: BillingType
): Promise<NskResponse<void>> => {
  const billingPayload = isDealConstructionEdit(dealBilling)
    ? convertDealConstructionToPayload(dealBilling)
    : dealBilling;

  return postRequest(
    queryString.stringifyUrl({
      url: generatePath('/deals/:deal_id/deal_billings', {
        deal_id: dealId
      }),
      query: { version: 'v2' }
    }),
    {
      dealBilling: billingPayload,
      billingType
    }
  );
};

export const update = async (
  dealBilling: DealConstructionEdit | DealSettlementEdit,
  dealBillingId: number,
  dealId: number
): Promise<NskResponse<void>> => {
  const billingPayload = isDealConstructionEdit(dealBilling)
    ? convertDealConstructionToPayload(dealBilling)
    : dealBilling;

  return putRequest(
    queryString.stringifyUrl({
      url: generatePath('/deals/:deal_id/deal_billings/:id', {
        deal_id: dealId,
        id: dealBillingId
      }),
      query: { version: 'v2' }
    }),
    { dealBilling: billingPayload }
  );
};

export const destroy = async (
  dealBilling: DealBilling | DealSettlement,
  dealId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    generatePath('/deals/:deal_id/deal_billings/:id', {
      deal_id: dealId,
      id: dealBilling.id
    })
  );

export const updateSeq = async (
  dealBillings: DealConstruction[] | DealSettlement[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(
    generatePath('/deals/:deal_id/deal_billings/update_seq', {
      deal_id: dealId
    }),
    { dealBillings }
  );
